import React from 'react';
import {twMerge} from 'tailwind-merge';
import { Image } from '../../../../components/image/image';
import { CtaButton } from './../cta-button/cta-button';

interface ConcertAniversaryProps {
    festivalLogo?: React.JSX.Element;
    aniversaryLogo?: React.JSX.Element;
    aniversaryDescription?: string;
    buttonText?: string;
    containerClassName?: string;
    contentClassName?: string;
    buttonClassName?: string;
}

const Anniversary: React.FC<ConcertAniversaryProps> = ({
    festivalLogo,
    aniversaryLogo,
    aniversaryDescription,
    buttonText = 'TÌM HIỂU THÊM',
    containerClassName = '',
    contentClassName = '',
    buttonClassName = '',
}) => {
    const containerStyle = twMerge(
        `relative w-full max-w-[2000px] mx-auto min-h-[783px] max-h-[1174px]
		bg-[#0b0033] overflow-hidden font-sans text-center text-white`,
        containerClassName,
    );
    const contentStyle = twMerge(`flex flex-col justify-center items-center max-w-[996px] mx-auto md:mt-[200px] mt-[106px]`, contentClassName);
    const buttonStyle = twMerge(`mx-auto w-[20%] min-w-[291px] max-w-[665px]`, buttonClassName);
    return (
        <div className={containerStyle}>
            {/* Đặt hình ảnh ở đây */}
            {/* z-0: Background */}
            <Image
                src="https://static.kidsplaza.vn/assets/festival2025/vuon-concert-2025/images/hero-bg.png"
                alt="Background"
                layout="fill"
                objectFit="fill"
                className="z-0"
                priority
            />

            {/* z-10: Flares */}
            <Image
                src="https://static.kidsplaza.vn/assets/festival2025/vuon-concert-2025/images/optimized/hero-flare-2.webp"
                alt="Pink Flare"
                width={900}
                height={900}
                className="absolute -bottom-60 right-[-450px] top-[-450px] mix-blend-lighten"
            />

            <Image
                src="https://static.kidsplaza.vn/assets/festival2025/vuon-concert-2025/images/optimized/hero-flare-2.webp"
                alt="Pink Flare"
                width={900}
                height={900}
                className="absolute bottom-10 left-[-450px] z-10  mix-blend-lighten"
            />

            <Image
                src="https://static.kidsplaza.vn/assets/festival2025/vuon-concert-2025/images/optimized/hero-flare-2.webp"
                alt="Pink Flare"
                width={900}
                height={900}
                className="absolute -bottom-[350px] right-[-250px] mix-blend-lighten"
            />

            {/*<Image*/}
            {/*    src="https://static.kidsplaza.vn/assets/festival2025/vuon-concert-2025/images/crane-logo.png"*/}
            {/*    alt="Pink Flare"*/}
            {/*    width={1007}*/}
            {/*    height={576}*/}
            {/*    className="*/}
            {/*        absolute mix-blend-lighten aspect-[1007/576] rotate-[-6deg]*/}
            {/*        left-1/2 top-1/4 -translate-x-1/2 -translate-y-1/2*/}

            {/*    "*/}
            {/*/>*/}

          <div className="absolute
        top-[20%] left-[14.77%]
        w-[70.06%] h-[34.11%]
        xs:top-[20%] xs:left-[22.77%] xs:w-[53.06%] xs:h-[34.11%]
        sm:top-[20%] sm:left-[22.77%] sm:w-[53.06%] sm:h-[34.11%]
        md:top-[20%] md:left-[22.77%] md:w-[53.06%] md:h-[34.11%]
        lg:top-[20%] lg:left-[22.77%] lg:w-[53.06%] lg:h-[34.11%]
        xl:top-[20%] xl:left-[22.77%] xl:w-[53.06%] xl:h-[34.11%]">
            <Image
              src={`https://static.kidsplaza.vn/assets/festival2025/vuon-concert-2025/images/supper-banner/phoenix.png`}
              alt="Phoenix"
              fill
              className="object-contain object-top mix-blend-screen"
            />
          </div>

            {/* Content */}
            <div className="z-40 mt-11 relative justify-center items-center w-full max-w-[1200px] mx-auto h-full">
                <div className='w-full flex justify-center items-center'>
                    {festivalLogo}
                </div>
                <div className={contentStyle}>
                    {aniversaryLogo}
                    <div className="w-full px-5 pb-5">
                        <p className="text-justify font-montserrat font-bold">{aniversaryDescription}</p>
                    </div>
                    <CtaButton
                        text={buttonText}
                        className={buttonStyle}
                        contentClassName='font-bold text-[12px] md:text-[24px] font-next_roboto'
                    />
                </div>
            </div>
        </div>
    );
};

export default Anniversary;
